const DEFAULT_GAME_FORM = {
  title: '',
  location_name: '',
  city: '',
  zip_code: '',
  date_time: '',
  min_players: 2,
  max_players: 10,
  skill_level_min: 'Unranked',
  skill_level_max: 'Elite',
  age_min: 13,
  age_max: 99,
  court_type: 'full_court',
  description: '',
  public_share_message: '',
  host_is_participant: true,
  privacy: 'public',
  is_private: false,
};

const compactIds = (values) => (
  [...new Set((Array.isArray(values) ? values : []).filter(Boolean))]
);

export const getDuplicateGameSource = (game = {}) => ({
  title: game.title || '',
  location_name: game.location_name || '',
  address: game.address || '',
  city: game.city || '',
  zip_code: game.zip_code || '',
  latitude: game.latitude ?? null,
  longitude: game.longitude ?? null,
  place_id: game.place_id || null,
  min_players: game.min_players ?? 2,
  max_players: game.max_players ?? 10,
  skill_level_min: game.skill_level_min || 'Unranked',
  skill_level_max: game.skill_level_max || 'Elite',
  age_min: game.age_min ?? 13,
  age_max: game.age_max ?? 99,
  court_type: game.court_type || 'full_court',
  description: game.description || '',
  public_share_message: game.public_share_message || '',
  privacy: game.privacy || 'public',
  is_private: game.is_private === true,
  run_club_ids: compactIds(
    game.run_club_ids?.length ? game.run_club_ids : [game.run_club_id]
  ),
});

export const buildDuplicateGameDraft = (game = {}) => {
  const source = getDuplicateGameSource(game);
  const hasReusableLocation = Boolean(source.location_name && source.address);

  return {
    formData: {
      ...DEFAULT_GAME_FORM,
      title: source.title,
      location_name: source.location_name,
      city: source.city,
      zip_code: source.zip_code,
      min_players: source.min_players,
      max_players: source.max_players,
      skill_level_min: source.skill_level_min,
      skill_level_max: source.skill_level_max,
      age_min: source.age_min,
      age_max: source.age_max,
      court_type: source.court_type,
      description: source.description,
      public_share_message: source.public_share_message,
      privacy: source.privacy,
      is_private: source.is_private,
      // A duplicate always requires a newly selected or confirmed time.
      date_time: '',
      // Participation is new-session state, not reusable configuration.
      host_is_participant: true,
    },
    locationInput: source.address || source.location_name,
    selectedPlace: hasReusableLocation ? {
      place_id: source.place_id,
      location_name: source.location_name,
      formatted_address: source.address,
      city: source.city,
      zip_code: source.zip_code,
      lat: source.latitude ?? undefined,
      lng: source.longitude ?? undefined,
      inputLabel: source.address || source.location_name,
      isRecentLocation: true,
    } : null,
    selectedClubIds: [...source.run_club_ids],
  };
};
